import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { MediaFileFragmentDoc } from '../../../../fragments/__generated__/file.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScheduledPostsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetScheduledPostsQuery = { __typename?: 'Query', scheduledPosts: Array<{ __typename?: 'ScheduledPost', id: string, uuid: string, content?: string | null, publishAt: number, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }> }> };


export const GetScheduledPostsDocument = gql`
    query GetScheduledPosts {
  scheduledPosts {
    id
    uuid
    content
    publishAt
    mediaFiles {
      ...MediaFile
    }
  }
}
    ${MediaFileFragmentDoc}`;

/**
 * __useGetScheduledPostsQuery__
 *
 * To run a query within a React component, call `useGetScheduledPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduledPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
      }
export function useGetScheduledPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
        }
// @ts-ignore
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>;
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduledPostsQuery | undefined, GetScheduledPostsQueryVariables>;
export function useGetScheduledPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>(GetScheduledPostsDocument, options);
        }
export type GetScheduledPostsQueryHookResult = ReturnType<typeof useGetScheduledPostsQuery>;
export type GetScheduledPostsLazyQueryHookResult = ReturnType<typeof useGetScheduledPostsLazyQuery>;
export type GetScheduledPostsSuspenseQueryHookResult = ReturnType<typeof useGetScheduledPostsSuspenseQuery>;
export type GetScheduledPostsQueryResult = Apollo.QueryResult<GetScheduledPostsQuery, GetScheduledPostsQueryVariables>;